import styled from "styled-components";

import * as Style from "style";

export const TableFooter = styled.tfoot`
  background: ${Style.Color.White};
`;
